/**
 * The CRM's language binding (board card AIW-CN).
 *
 * The mechanism is `@aiw/i18n`; the dictionary is the shared AIW catalogue, which
 * currently holds the CRM's copy too. The installer portal keeps its own table and
 * runs on the same mechanism, so there is exactly one way language works here.
 *
 * Storage is per face because each face is its own origin — a staff member and an
 * installer on the same Mac still get their own choice.
 */
import {makeLanguageContext, useLangState, DICTIONARIES, type Lang} from '@aiw/i18n/react';

const KEY = 'aiw.crm.lang';

export const {LanguageContext, LanguageProvider, useT} = makeLanguageContext(DICTIONARIES);

/** Mounted once, above the router: the choice survives navigation and reloads. */
export function useCrmLang() {
  return useLangState(KEY, DICTIONARIES);
}

export type {Lang};
